<script lang="ts">
  let {
    value = $bindable(''),
    options,
    ariaLabel,
    class: className = ''
  }: {
    value?: string;
    options: Array<{ value: string; label: string }>;
    ariaLabel?: string;
    class?: string;
  } = $props();

  let container: HTMLDivElement | undefined = $state();

  function handleKey(e: KeyboardEvent) {
    const idx = options.findIndex((o) => o.value === value);
    if (idx === -1) return;
    let next = idx;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      next = (idx + 1) % options.length;
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      next = (idx - 1 + options.length) % options.length;
    } else if (e.key === 'Home') {
      next = 0;
    } else if (e.key === 'End') {
      next = options.length - 1;
    } else {
      return;
    }
    const target = options[next];
    if (!target) return;
    e.preventDefault();
    value = target.value;
    const buttons = container?.querySelectorAll<HTMLButtonElement>('button');
    buttons?.[next]?.focus();
  }
</script>

<div
  class="segmented {className}"
  role="radiogroup"
  aria-label={ariaLabel}
  tabindex="-1"
  bind:this={container}
  onkeydown={handleKey}
>
  {#each options as opt (opt.value)}
    <button
      type="button"
      role="radio"
      aria-checked={value === opt.value}
      tabindex={value === opt.value ? 0 : -1}
      class="segment"
      data-active={value === opt.value || undefined}
      onclick={() => (value = opt.value)}
    >
      {opt.label}
    </button>
  {/each}
</div>

<style>
  .segmented {
    display: inline-flex;
    align-items: center;
    padding: 2px;
    gap: 2px;
    background: var(--color-surface-sunken);
    border: var(--border-width) solid var(--color-border);
    border-radius: var(--radius-sm);
  }

  .segment {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    padding: 0 var(--space-4);
    font-family: inherit;
    font-size: 0.75rem;
    font-weight: var(--weight-semibold);
    line-height: 1;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: var(--color-accent);
    background: transparent;
    border: var(--border-width) solid var(--color-accent);
    border-radius: var(--radius-sm);
    cursor: pointer;
    transition:
      background var(--dur-fast) var(--ease-out),
      color var(--dur-fast) var(--ease-out),
      border-color var(--dur-fast) var(--ease-out);
  }

  .segment:hover:not([data-active]) {
    background: var(--color-accent-tint);
  }

  .segment[data-active] {
    background: var(--color-accent);
    color: var(--color-accent-fg);
    border-color: var(--color-accent);
  }

  .segment:focus-visible {
    outline: var(--focus-ring-width) solid var(--color-focus-ring);
    outline-offset: 1px;
  }
</style>